import React, { createContext, useState, useContext } from "react";

const EditModeContext = createContext();

export const useEditMode = () => {
  return useContext(EditModeContext);
};

export const EditModeProvider = ({ children }) => {
  const [isEditMode, setIsEditMode] = useState(false);

  const toggleEditMode = () => {
    setIsEditMode((prevMode) => !prevMode);
  };

  return (
    <EditModeContext.Provider
      value={{ isEditMode, toggleEditMode, setIsEditMode }}
    >
      {children}
    </EditModeContext.Provider>
  );
};
